

export default (state = [], action) => {
  if (action.type == "SET_PESSAH2") {
    return action.value;
  }
  return state;
};